
<template>
  <div class="login clearBoth">
    <!--<div class="login-logo">
      <img src="./images/logo.jpg" alt />
    </div>-->
    <div class="login-form">
      <form>
        <p class="noMargin">用户名</p>
        <label>
          <input type="text" v-model="username" placeholder="用户名" />
        </label>
        <p>密码</p>
        <label>
          <input type="password" v-model="password" placeholder="密码" />
        </label>
        <p v-if="codeInfo!=2">验证码</p>

        <div class="code-wrap" v-if="codeInfo!=2">
          <label>
            <input type="text" v-model="code" placeholder="验证码" />
          </label>
          <img class="code" @click="refreshVerifyCode" :src="code_url" />
        </div>
        <div>
          <button @click.prevent="loginApp" class="normal-btn" :disabled="isButtonDisabled" :class="['submit'+ismobile]">{{ buttonText }}</button>
          <!--隐藏手机电脑版本切换-->
          <!--<button @click="goPage('https://m.dc198.com/login')" class="normal-btn" :class="['submit2'+ismobile]" >手机版</button>-->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getCode } from '@/service/user'
import { mapActions } from "vuex";

var nv='';
var fromurl=document.referrer;
if (fromurl.indexOf("m.dc198.com") > -1)
{
  var nv='1';
}

export default {
  name: "login",
  data() {
    return {
      buttonText: '登录',
      isButtonDisabled: false,
      num: 1,
      username: '',
      password: "",
      code: "",
      ismobile:nv,
      codeInfo:''
    };
  },
  computed: {
    code_url() {
      return `/api/ssc_golang/v1/user/captcha?n=${this.num}&`+'random='+new Date().getTime();
    }
  },
  mounted() {
    this.queries = this.$route.query;
    this.getCode();
  },
  watch: {
    code() {
      if(this.code.length>4){
        this.code = this.code.substring(0,4);
      }
    }
  },
  methods: {
    ...mapActions("root", ["login"]),
    ...mapActions("table", {
      getData: "load_d23_data"
    }),
    refreshVerifyCode() {
      this.num++;
    },
    async getCode() {
        this.codeInfo = await getCode();
        if(this.codeInfo==1){
          this.refreshVerifyCode();
        }
    },
    async loginApp() {
      if(this.codeInfo!=2){
        var info = this.$validate.group(
          this.$validate("username", this.username),
          this.$validate("password", this.password),
          this.$validate("code", this.code)
        );
      }else{
        var info = this.$validate.group(
          this.$validate("username", this.username),
          this.$validate("password", this.password)
        );
      }

      if (info) return this.$Message.error(info);
      this.buttonText = '登录中，请稍候';
      this.isButtonDisabled = true;
      const res = await this.login({
        username: this.username,
        password: this.password,
        code: this.code
      });

      this.num++;

      if (res.result !== "ok"){
        if(res.msg=="请您进行密码更换")
        {
          this.password = "";
          this.code = "";
          this.$MessageBox.show('d28', {
            title: '修改密码'
          });
        }
        this.isButtonDisabled = false;
        this.buttonText = '登录';
        return this.$Message.error(res.msg);
      }
      this.getData();
      if(res.msg=='3'){
          this.isButtonDisabled = false;
          this.buttonText = '登录';
          this.$Message.error('该帐号已被冻结，请联系您的上级！');
      }
      // this.$router.replace(this.queries.path || '/home/pk10');
      this.buttonText = '登录成功，正在跳转';
      const path = this.queries.path || "";
      if (path != "")
        this.$router.replace("/agreement?path=" + this.queries.path);
      else this.$router.replace("/agreement");
    },
    goPage(url)
    {
      window.location.href = url;
      window.event.returnValue=false;
    }
  }
};
</script>

<style lang="stylus">
.dialog_title{background: linear-gradient(#f3382c,#da2d23);}
.submit > button{
  outline: none;
  padding: 0;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #aaa;
  color: #fff;
  width: 80px;
  height: 35px;
  margin: 0 5px;
  background-color: #909399;}
.submit > button.active{background-color: #ef4421;}
html, body {
  height: 100%;
}
</style>
<style scoped lang="stylus">
@media screen and (max-width: 900px) { 
  .login {left: 0px !important;}  
} 
.login {
  bottom:20px;
  left:200px;
  width: 380px;
  height: 350px;
  position: absolute;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0.15);

  > div {
    float: left;
  }

  .login-logo {
    width: 457px;
    height: 100%;
    text-align: center;

    &:after {
      display: inline-block;
      content: '';
      width: 0;
      height: 100%;
      vertical-align: middle;
    }

    > img {
      vertical-align: middle;
    }
  }

  .login-form {
    width: 380px;
    height: 100%;
    padding: 27px 35px;
    box-sizing: border-box;
    background-color: rgba(0,0,0,0.5);

    form {
      p {
        color: #ffffff;
        margin-top: 14px;
      }

      .noMargin {
        margin-top: 5px;
      }

      label {
        display: block;
        margin-top: 10px;

        input {
          width: 100%;
          height: 43px;
          padding: 0 10px;
          box-sizing: border-box;
          line-height: 35px;
        }
      }

      .code-wrap {
        position: relative;
        box-sizing: border-box;
        padding-right: 115px;

        .code {
          top: 0;
          right: 0;
          width: 105px;
          height: 100%;
          position: absolute;
          margin-top: 0;
          background-color: orangered;
        }
      }

      .submit {
        color: #ffffff;
        width: 100%;
        height: 43px;
        font-size: 16px;
        margin-top: 20px;
        background-color: #ef4421;
      }
      .submit1 {
        color: #ffffff;
        width: 48%;
        height: 43px;
        font-size: 16px;
        margin-top: 20px;
        background-color: #ef4421;
        float:left;
      }
      .submit2 {
        display:none;
        color: #ffffff;
        width: 48%;
        height: 43px;
        font-size: 16px;
        margin-top: 20px;
        background-color: #28b32a;
        float:right;
      }
      .submit21 {
        display:block;
        color: #ffffff;
        width: 48%;
        height: 43px;
        font-size: 16px;
        margin-top: 20px;
        background-color: #28b32a;
        float:right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue